<template>
  <div :class="classes">
    <label v-if="label" :for="computedId">{{ label }}</label>
    <div class="input-wrapper">
      <slot name="prefix" />
      <Asd20Icon v-if="icon" :name="icon" :size="iconSize" />

      <input
        :id="computedId"
        :value="value"
        v-bind="$attrs"
        v-on="listeners"
        :aria-label="hideLabel ? label : ''"
        @input="input"
      />

      <slot name="suffix" />
    </div>
    <div
      class="asd20-text-input__help-text"
      v-if="helpText"
      v-html="helpText"
    />
    <div
      class="asd20-text-input__validation-error"
      v-for="(v, index) in validationErrors"
      :key="index"
      v-html="v"
    />
  </div>
</template>

<script>
import inputComponentMixin from '../../../mixins/inputComponentMixin'
import Asd20Icon from '../../atoms/Asd20Icon'

export default {
  name: 'Asd20TextInput',
  inheritAttrs: false,
  mixins: [inputComponentMixin],
  components: { Asd20Icon },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

$input-focus-color: var(--color__accent-t50);

.asd20-text-input {
  position: relative;
  align-items: center;
  width: 100%;
  margin: 0 0 space(0.5) 0;

  label {
    position: relative;
    display: block;
    width: 100%;
    color: var(--website-card__reverse-background-color);
    margin-bottom: space(0.125);
  }

  input {
    -webkit-appearance: none !important;
    box-sizing: border-box;
    flex-grow: 1;
    width: inherit;
    height: inherit;
    // height: space(1.5);
    margin: 0;
    color: var(--website-card__reverse-background-color);
    border: 2px solid var(--color__accent);
    border-radius: 0;
    font-size: 1rem;
    line-height: 1;
    padding: space(0.25) space(0.25);
    background: white;
    transition: background asd20-speed(1) ease;
    &:not(:first-child) {
      margin-left: space(0.5);
    }
    &:not(:last-child) {
      margin-right: space(0.5);
    }

    &::-webkit-search-decoration {
      -webkit-appearance: none !important;
    }

    &:focus {
      // outline: none;
      box-shadow: 0 0 0 5px $input-focus-color inset;
    }

    &::-webkit-input-placeholder {
      opacity: 1;
      color: var(--color__secondary-t50);
      font-size: space(0.75);
    }
    &::-moz-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
    &:-ms-input-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
    &:-moz-placeholder {
      opacity: 1;
      color: var(--color__primary-t50);
    }
  }

  &__help-text {
    color: var(--website-card__reverse-background-color);
    font-size: 0.75rem;
    margin-top: space(0.125);
  }

  &__validation-error {
    color: var(--color__danger-s20);
    font-size: 0.75rem;
    margin-top: space(0.125);
  }

  &--has-errors {
    label {
      color: var(--color__danger-s20);
    }
    input {
      border-color: var(--color__danger);
      &:focus {
        box-shadow: 0 0 0 5px var(--color__danger) inset;
      }
    }
  }
}

.input-wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
}
</style>
